import { deleteTasks as _deleteTasks } from '@griply/services';
import { ID } from '@griply/types';
import {
  collection,
  deleteDoc,
  doc,
  Firestore,
  writeBatch,
} from 'firebase/firestore';

import { getAuthentication, getDatabase } from './helpers';

export const deleteTasks = async (taskIds: ID[]): Promise<void> => {
  const user = (await getAuthentication()).currentUser;

  if (!user) {
    throw Error('unauthenticated');
  }

  await _deleteTasks({
    taskIds,
    collection,
    doc,
    deleteDoc,
    db: getDatabase(),
    writeBatch: (_db) => writeBatch(_db as Firestore),
  });
};
